import React from 'react';
import {
  EVENT_YEAR_TEAM,
  EVENT_TITLE,
  INTRO_TEXT,
  EVENT_MONTH,
  EVENT_DAY_TEXT,
  EVENT_DAY_NUMBER,
  EVENT_FULL_YEAR,
  EVENT_TIME,
  EVENT_LOCATION_NAME,
  EVENT_LOCATION_CITY
} from '../constants.ts';
import logo from '../logorl.png';

export const Header: React.FC = () => {
  return (
    <header className="w-full p-8 text-center text-text-white font-montserrat">
      {/* Company Logo */}
      <div className="mb-6 flex justify-center items-center w-full">
        <img 
          src={logo}
          alt="Ralph Lauren Logo" 
          className="h-16 md:h-20 w-auto object-contain"
        />
      </div>

      {/* 2025 TEAM */}
      <p className="text-xl tracking-widest uppercase mb-2" aria-label="Year and Team">{EVENT_YEAR_TEAM}</p>

      {/* HOLIDAY CELEBRATION */}
      <h1 className="text-4xl sm:text-5xl md:text-6xl font-playfair font-bold text-accent-gold tracking-wider uppercase mb-6 text-center w-full px-4" aria-label="Event Title">
        {EVENT_TITLE}
      </h1>

      {/* Introductory Text */}
      <div className="p-4 md:p-8 bg-primary-bg text-text-white max-w-3xl mx-auto leading-relaxed mb-8" aria-label="Event Description">
        <p className="text-base sm:text-lg">
          {INTRO_TEXT}
        </p>
      </div>

      {/* Date Block */}
      <div className="flex flex-col items-center space-y-4 mb-8">
        <p className="text-accent-gold text-lg uppercase tracking-wide" aria-label="Event Month">{EVENT_MONTH}</p>
        <div className="flex items-center space-x-4">
          <p className="text-accent-gold text-lg uppercase tracking-wide w-24 border-b border-accent-gold pb-2" aria-label="Event Day of Week">{EVENT_DAY_TEXT}</p>
          <p className="text-accent-gold text-7xl font-playfair font-bold" aria-label="Event Day Number">{EVENT_DAY_NUMBER}</p>
          <p className="text-accent-gold text-lg uppercase tracking-wide w-24 border-b border-accent-gold pb-2" aria-label="Event Time">{EVENT_TIME}</p>
        </div>
        <p className="text-accent-gold text-lg uppercase tracking-wide" aria-label="Event Year">{EVENT_FULL_YEAR}</p>
      </div>

      {/* Location */}
      <div className="text-accent-gold text-xl tracking-wide uppercase leading-loose" aria-label="Event Location">
        <p>{EVENT_LOCATION_NAME}</p>
        <p>{EVENT_LOCATION_CITY}</p>
      </div>
    </header>
  );
};